import { createSlice } from "@reduxjs/toolkit";
import { encrypt } from "../../../helpers/encrypt";

const initialState = {
  token: localStorage.getItem("token"),
  userDetails: localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails"))
    : localStorage.getItem("userDetails"),
  rememberMe: localStorage.getItem("rememberMe") ? true : false,
  username: localStorage.getItem("username") || "",
  password: localStorage.getItem("password") || "",
  credential:
    localStorage.getItem("username") && localStorage.getItem("password")
      ? encrypt({
          username: localStorage.getItem("username"),
          password: localStorage.getItem("password"),
        })
      : null,
  validMixCount : localStorage.getItem("validMixCount"),
};

export const loginAction = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLoginData: (state, action) => {
      state.token = action.payload.token;
      state.userDetails = action.payload.userDetails;
      state.validMixCount = action.payload.validMixCount;
      localStorage.setItem("validMixCount", action.payload.validMixCount);
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem(
        "userDetails",
        JSON.stringify(action.payload.userDetails)
      );
      state.rememberMe = action.payload.rememberMe ? true : false;
      if (action.payload.rememberMe) {
        const credential = encrypt({
          username: action.payload.username,
          password: action.payload.password,
        });
        state.username = action.payload.username;
        state.password = action.payload.password;
        state.credential = credential;
        localStorage.setItem("rememberMe", "true");
        localStorage.setItem("username", action.payload.username);
        localStorage.setItem("password", action.payload.password);
      } else {
        state.username = "";
        state.password = "";
        state.credential = null;
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("username");
        localStorage.removeItem("password");
      }
    },
    setRememberMe: (state) => {
      state.rememberMe = !state.rememberMe;
    },
  },
});

export const { setLoginData, setRememberMe } = loginAction.actions;
export const selectLoginData = (state) => state.login;

export default loginAction.reducer;
